import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from "./pages/Footer";
import Home from "./pages/Home";
import Navbar from "./pages/Navbar";

import About from './pages/About';
import ContactUsPage from './pages/ContactUsPage';
import InverterProductPage from './pages/InverterProductPage';



const App = () => {
  return (
    <Router>
      <div className="min-h-screen">
       
        <Navbar />
        <Routes>
         <Route path="/" element={<Home />} />
          <Route path="/about" element={<About/>} />
           <Route path="/contact-us" element={<ContactUsPage/>} />
           <Route path="/Products" element={<InverterProductPage/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;